<template>
    <div>
        <!--
        <base-alert type="warning" class="notice" dismissible>
            <p>График работы онлайн-платформы в праздники:</p>

            <ul>
                <li><span class="strong">31 декабря - 3 января &mdash; выходные дни</span></li>
                <li>С 4 января &ndash; занятия по групповому и индивидуальному <a
                        href="https://poliglotiki.com/home-teacher/schedule">расписанию</a></li>
            </ul>

            <p>Поздравляем вас с праздниками и желаем хороших выходных!</p>
        </base-alert>
        -->
    </div>
</template>

<script>
    export default {
        name: "TimetableNotice"
    }
</script>

<style scoped>
    .notice p, .notice, .notice a {
        font-size: 16px;
        color: white;
    }

    .strong {
        font-family: "Manrope Bold";
    }

    .notice a {
        text-decoration: underline;
    }
</style>
